(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Treeview", [], factory);
	else if(typeof exports === 'object')
		exports["Treeview"] = factory();
	else
		root["Treeview"] = factory();
})(this, function() {
return 